import React, { useEffect, useState } from "react";
// import { toast } from "react-hot-toast";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "../Images/noImage.jpg";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import profileP from "../Images/profile-pic.png";
function Sidebar({ HideSidebar }) {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState("");
  const [toggle, setoggle] = useState(false);
  const [toggleExpenses, setToggleExpenses] = useState(false);
  const userRole = localStorage.getItem("role");
  // const handleClick = () => {
  //   if (document.querySelector("#DarkSwitch").checked) {
  //     document.body.classList.add("drakmode");
  //   } else {
  //     document.body.classList.remove("drakmode");
  //   }
  // };
  const roles = [
    "sales",
    "survey",
    "telecalling",
    "data entry",
    "branch manager",
    "freelancer",
  ];

  const fetchAdminLoginData = async () => {
    // const res = await HomeService.getLoginProfile();
    // console.log("this is login profile data", res);
    // if (res && res?.status) {
    //   console.log("GTR23", res);
    //   setProfileData(res?.data);
    // }
  };
  const handlClick = () => {
    const sidebar = document.querySelector(".sidebarwrap");
    if (sidebar) {
      sidebar.classList.remove("show");
    }
  };

  // >>>Handle Admin Logout<<<
  const handleLogOut = () => {
    toast.success("Logout SuccessFull");
    localStorage.clear();
    navigate("/login");
  };
  useEffect(() => {
    fetchAdminLoginData();
  }, []);
  return (
    <>
      <div className="sidebarwrap">
        <i
          style={{
            position: "absolute",
            top: "0px",
            right: "0px",
            color: "rgb(133, 218, 79)",
            cursor: "pointer",
            fontSize: "25px",
          }}
          class="fa-solid fa-caret-left left_arrow"
          onClick={HideSidebar}
        ></i>
        <div className="sidebar_logo_div">
          <p
            style={{
              color: "#fff",
              fontSize: "30px",
              fontWeight: "600",
              textAlign: "left",
              marginTop: "20px",
              marginLeft: "20px",
            }}
          >
            <span
              style={{
                color: "rgb(172, 216, 65)",
              }}
            >
              College
            </span>
            <span style={{ color: "red" }}>O</span>
            Pedia
          </p>
        </div>
        <p
          style={{
            color: "#fff",
            fontSize: "15px",
            fontWeight: "600",
            textAlign: "left",
            marginTop: "20px",
            marginLeft: "15px",
          }}
        >
          MENU
        </p>
        <div className="sidebar_menu">
          <ul className="nav Menu_Nav accordion" id="sidemenu">
            {/* **Menu 1 Dashboard** */}
            <li className="menuline">
              <NavLink to="/" className="" onClick={handlClick}>
                <i class="fa-solid fa-cubes"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>

            {/* **Menu 2 City** */}
            <li
              className="menuline"
              // style={{
              //   display: ["superadmin", "branch manager"].includes(userRole)
              //     ? "block"
              //     : "none",
              // }}
            >
              <div className="menu-head" id="sidemenuhead2">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu2"
                  aria-expanded="true"
                  aria-controls="sidemenu2"
                >
                  {/* <i class="fa-solid fa-city"></i> */}
                  <i class="fa-solid fa-map-marker-alt"></i>
                  <span>All Master</span>
                </Link>
              </div>
              <div
                id="sidemenu2"
                className="collapse"
                aria-labelledby="sidemenuhead2"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/manage-country" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Manage Country
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-state" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Manage State
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-district" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      District
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-city" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      City
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-university" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      University
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/add-scholarship" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Scholarship
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-scholarship" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Scholarship
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-exam" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Exam
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-accredition" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Accredition
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            {/* Locality */}
            <li
              className="menuline"
              // style={{
              //   display: ["superadmin", "branch manager"].includes(userRole)
              //     ? "block"
              //     : "none",
              // }}
            >
              <div className="menu-head" id="sidemenuhead-locality">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-locality"
                  aria-expanded="true"
                  aria-controls="sidemenu-locality"
                >
                  {/* <span style={{ fontSize: "20px" }}>+</span> */}
                  <i class="fa-solid fa-city"></i>
                  <span>University</span>
                </Link>
              </div>
              <div
                id="sidemenu-locality"
                className="collapse"
                aria-labelledby="sidemenuhead-locality"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/manage-course-category" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Course Category
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-course-name" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Course
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/add-college-university" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      College/University
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/manage-college-university"
                      onClick={handlClick}
                    >
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      College/University
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/add-course-adn-fees" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Course and Fees
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-course-adn-fees" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Course and Fees
                    </NavLink>
                  </li> */}
                </ul>
              </div>
            </li>

            {/* Course And Fees */}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-apartment">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-apartment"
                  aria-expanded="true"
                  aria-controls="sidemenu-apartment"
                >
                  {/* <span style={{ fontSize: "20px" }}>+</span> */}
                  <i class="fa-solid fa-building"></i>
                  <span>Course & Fees</span>
                </Link>
              </div>
              <div
                id="sidemenu-apartment"
                className="collapse"
                aria-labelledby="sidemenuhead-apartment"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-course-adn-fees" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Course and Fees
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-course-and-fees" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Course and Fees
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            {/* Scholarship */}
            {/* <li className="menuline">
              <div className="menu-head" id="sidemenuhead-scholarship">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-scholarship"
                  aria-expanded="true"
                  aria-controls="sidemenu-scholarship"
                >
                  <span style={{ fontSize: "20px" }}>+</span>
                  <i class="fa-solid fa-bolt"></i>
                  <span>Scholarship</span>
                </Link>
              </div>
              <div
                id="sidemenu-scholarship"
                className="collapse"
                aria-labelledby="sidemenuhead-scholarship"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-scholarship" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Scholarship
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-scholarship" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Scholarship
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}

            {/* Facility */}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-facility">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-facility"
                  aria-expanded="true"
                  aria-controls="sidemenu-facility"
                >
                  {/* <span style={{ fontSize: "20px" }}>+</span> */}
                  <i class="fa-solid fa-user-shield"></i>
                  <span>Facility </span>
                </Link>
              </div>
              <div
                id="sidemenu-facility"
                className="collapse"
                aria-labelledby="sidemenuhead-facility"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-facility" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Facility
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-facility" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Facility
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            {/* Blog */}
            <li className="menuline">
              <div className="menu-head" id="sidemenuhead-blog">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-blog"
                  aria-expanded="true"
                  aria-controls="sidemenu-blog"
                >
                  {/* <span style={{ fontSize: "20px" }}>+</span> */}
                  <i class="fa-solid fa-user-shield"></i>
                  <span>Blogs and News </span>
                </Link>
              </div>
              <div
                id="sidemenu-blog"
                className="collapse"
                aria-labelledby="sidemenuhead-blog"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-blog" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Blog
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-blog" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Blog
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            {/* Gallery */}
            {/* <li
              className="menuline">
              <div className="menu-head" id="sidemenuhead-gallery">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-gallery"
                  aria-expanded="true"
                  aria-controls="sidemenu-gallery"
                >
                  <i class="fa-solid fa-user-shield"></i>
                  <span>Gallery </span>
                </Link>
              </div>
              <div
                id="sidemenu-gallery"
                className="collapse"
                aria-labelledby="sidemenuhead-gallery"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/manage-gallery" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Gallery
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}

            {/* **Menu 3 Property Type** */}
            <li
              className="menuline"
              // style={{
              //   display: [
              //     "superadmin",
              //     "branch manager",
              //     "telecalling",
              //     "data entry",
              //   ].includes(userRole)
              //     ? "block"
              //     : "none",
              // }}
            >
              <div className="menu-head" id="sidemenuhead3">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu3"
                  aria-expanded="true"
                  aria-controls="sidemenu3"
                >
                  <i class="fa-solid fa-key"></i>
                  <span>Review</span>
                </Link>
              </div>
              {/* <div
                id="sidemenu3"
                className="collapse"
                aria-labelledby="sidemenuhead3"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-property-type" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Property Type
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-property-type" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Property Type
                    </NavLink>
                  </li>
                </ul>
              </div> */}
            </li>

            {/* {toggle && <li className="menuline"
              style={{
                display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                paddingLeft: "25px",
              }}
            >
              <div className="menu-head" id="sidemenuhead8">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu8"
                  aria-expanded="true"
                  aria-controls="sidemenu8"
                >

                  <i class="fa-solid fa-indian-rupee-sign"></i>
                  <span>Subscription</span>
                </Link>
              </div>
              <div
                id="sidemenu8"
                className="collapse"
                aria-labelledby="sidemenuhead8"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-subscription" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Subscription
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-subscription" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Subscription
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>} */}

            {/* **Sales Report** */}
            {/* <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <NavLink to="/sales" className="" onClick={handlClick}>
                <i class="fa-solid fa-receipt"></i>
                <span>Sales Report</span>
              </NavLink>
            </li> */}

            {/* Expenses */}
            {/* **Menu  Sales** */}
            {/* <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead7">
                <Link
                  // to="/sales"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu25"
                  aria-expanded="true"
                  aria-controls="sidemenu25"
                  onClick={() => {
                    setToggleExpenses(!toggleExpenses);
                  }}
                >
                  <i class="fa-solid fa-sack-xmark"></i>
                  <span
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      columnGap: "90px",
                    }}
                  >
                    Expenses{" "}
                    <i
                      class={` margin-right fa-solid fa-caret-${
                        toggleExpenses ? "up" : "down"
                      }`}
                    ></i>
                  </span>
                </Link>
              </div>

              
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-commission">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-commission"
                      aria-expanded="true"
                      aria-controls="sidemenu-commission"
                    >
                      <i class="fa-solid fa-award"></i>
                      <span>Commission</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-commission"
                    className="collapse"
                    aria-labelledby="sidemenuhead-commission"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-commission" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Commission
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-commission" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Commission
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-salary">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-salary"
                      aria-expanded="true"
                      aria-controls="sidemenu-salary"
                    >
                      <i class="fa-solid fa-wallet"></i>
                      <span>Salary</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-salary"
                    className="collapse"
                    aria-labelledby="sidemenuhead-salary"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-salary" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Salary
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-salary" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Salary
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-rent">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-rent"
                      aria-expanded="true"
                      aria-controls="sidemenu-rent"
                    >
                      <i class="fa-solid fa-house-circle-check"></i>
                      <span>Rent</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-rent"
                    className="collapse"
                    aria-labelledby="sidemenuhead-rent"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-rent" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Rent
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-rent" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Rent
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-electricity">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-electricity"
                      aria-expanded="true"
                      aria-controls="sidemenu-electricity"
                    >
                      <i class="fa-solid fa-lightbulb"></i>
                      <span>Electricity</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-electricity"
                    className="collapse"
                    aria-labelledby="sidemenuhead-electricity"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-electricity" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Electricity
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-electricity" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Electricity
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div
                    className="menu-head"
                    id="sidemenuhead-telephone-n-internet"
                  >
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-telephone-n-internet"
                      aria-expanded="true"
                      aria-controls="sidemenu-telephone-n-internet"
                    >
                      <i class="fa-solid fa-wifi"></i>
                      <span>Telephone & Internet</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-telephone-n-internet"
                    className="collapse"
                    aria-labelledby="sidemenuhead-telephone-n-internet"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink
                          to="/add-telephone-n-internet"
                          onClick={handlClick}
                        >
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Telephone & Internet
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/manage-telephone-n-internet"
                          onClick={handlClick}
                        >
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Telephone & Internet
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-petrol">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-petrol"
                      aria-expanded="true"
                      aria-controls="sidemenu-petrol"
                    >
                      <i class="fa-solid fa-gas-pump"></i>
                      <span>Petrol</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-petrol"
                    className="collapse"
                    aria-labelledby="sidemenuhead-petrol"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-petrol" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Petrol
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/manage-petrol" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Petrol
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              
              {toggleExpenses && (
                <div
                  className="menuline"
                  style={{
                    // display: ["superadmin", "branch manager", "sales"].includes(userRole) ? "block" : "none",
                    paddingLeft: "25px",
                  }}
                >
                  <div className="menu-head" id="sidemenuhead-miscellaneous">
                    <Link
                      to="#"
                      className="btn btn-header-link"
                      data-toggle="collapse"
                      data-target="#sidemenu-miscellaneous"
                      aria-expanded="true"
                      aria-controls="sidemenu-miscellaneous"
                    >
                      <i class="fa-solid fa-layer-group"></i>
                      <span>Miscellaneous</span>
                    </Link>
                  </div>
                  <div
                    id="sidemenu-miscellaneous"
                    className="collapse"
                    aria-labelledby="sidemenuhead-miscellaneous"
                    data-parent="#sidemenu"
                  >
                    <ul className="Submenu">
                      <li>
                        <NavLink to="/add-miscellaneous" onClick={handlClick}>
                          <i className="fa-solid fa-angles-right mr-2"></i>Add
                          Miscellaneous
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/manage-miscellaneous"
                          onClick={handlClick}
                        >
                          <i className="fa-solid fa-angles-right mr-2"></i>
                          Manage Miscellaneous
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </li> */}

            {/* **Expense Report** */}
            {/* <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <NavLink to="/expense-report" className="" onClick={handlClick}>
                <i class="fa-solid fa-file-alt"></i>
                <span>Expense Report</span>
              </NavLink>
            </li> */}

            {/* Send Email */}
            {/* <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-sendemail">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-sendemail"
                  aria-expanded="true"
                  aria-controls="sidemenu-sendemail"
                >
                  <i class="fa-solid fa-paper-plane"></i>
                  <span>Send Mail</span>
                </Link>
              </div>
              <div
                id="sidemenu-sendemail"
                className="collapse"
                aria-labelledby="sidemenuhead-sendemail"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/send-email-to-staff" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Email to
                      Staff
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/sent-email-to-staff" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Staff
                      Emails History
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}

            {/* Hot Clients */}
            {/* <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <NavLink to="/hot-clients" className="" onClick={handlClick}>
                <i class="fa-solid fa-briefcase"></i>
                <span>Hot Clients</span>
              </NavLink>
            </li> */}

            {/* Sales Pipeline / Lead */}
            {/* <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead-sales-pipeline">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-sales-pipeline"
                  aria-expanded="true"
                  aria-controls="sidemenu-sales-pipeline"
                >
                  <i class="fa-solid fa-filter"></i>
                  <span>Leads</span>
                </Link>
              </div>
              <div
                id="sidemenu-sales-pipeline"
                className="collapse"
                aria-labelledby="sidemenuhead-sales-pipeline"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-sales-pipeline" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Lead
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-sales-pipeline" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Lead
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}

            {/* <div
              className="menu-head"
              style={{
                display: [
                  "superadmin",
                  "branch manager",
                  "telecalling",
                  "data entry",
                ].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <Link to="/work-sheet" className="btn btn-header-link">
                <i class="fa-solid fa-briefcase"></i>
                <span>Work Sheet</span>
              </Link>
            </div> */}

            {/*Blog Section*/}
            {/* <li
              className="menuline"
              style={{
                display: ["superadmin", "branch manager"].includes(userRole)
                  ? "block"
                  : "none",
              }}
            >
              <div className="menu-head" id="sidemenuhead2">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu2"
                  aria-expanded="true"
                  aria-controls="sidemenu2"
                >
                  
                  <i class="fa fa-rss"></i>
                  <span>Blog</span>
                </Link>
              </div>
              <div
                id="sidemenu2"
                className="collapse"
                aria-labelledby="sidemenuhead2"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-blog" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>
                      Add Blog
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-blog" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Blog
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}

            {/* Menu Access */}
            {/* <li className="menuline"
              style={{
                display: ["superadmin"].includes(userRole) ? "block" : "none"
              }}
            >
              <div className="menu-head" id="sidemenuhead-menu-access">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu-menu-access"
                  aria-expanded="true"
                  aria-controls="sidemenu-menu-access"
                >

                  <i class="fa-solid fa-bars"></i>
                  <span>Menu Access</span>
                </Link>
              </div>
              <div
                id="sidemenu-menu-access"
                className="collapse"
                aria-labelledby="sidemenuhead-menu-access"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-menu-access" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add
                      Menu Access
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-menu-access" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Menu Access
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}

            {/* **Menu 4 bHK** */}

            {/* <li className="menuline">
              <div className="menu-head" id="sidemenuhead4">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu4"
                  aria-expanded="true"
                  aria-controls="sidemenu4"
                >
               
                  <i class="fa-solid fa-building-user"></i>
                  <span>BHK</span>
                </Link>
              </div>
              <div
                id="sidemenu4"
                className="collapse"
                aria-labelledby="sidemenuhead4"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-bhk" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add BHK
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-bhk" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      BHK
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}

            {/* **Menu 5 Property Type** */}

            {/* <li className="menuline">
              <div className="menu-head" id="sidemenuhead5">
                <Link
                  to="#"
                  className="btn btn-header-link"
                  data-toggle="collapse"
                  data-target="#sidemenu5"
                  aria-expanded="true"
                  aria-controls="sidemenu5"
                >
               
                  <i class="fa-solid fa-house"></i>
                  <span>Floor</span>
                </Link>
              </div>
              <div
                id="sidemenu5"
                className="collapse"
                aria-labelledby="sidemenuhead5"
                data-parent="#sidemenu"
              >
                <ul className="Submenu">
                  <li>
                    <NavLink to="/add-floor" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Add Floor
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/manage-floor" onClick={handlClick}>
                      <i className="fa-solid fa-angles-right mr-2"></i>Manage
                      Floor
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li> */}

            {/* Menu * Log Out */}
            {/* <li onClick={handleLogOut} className="menuline">
              <Link>
                <i className="fa-solid fa-right-from-bracket"></i>
                <span>Logout</span>
              </Link>
            </li> */}
          </ul>
        </div>
        <hr className="hr_line" />
        <div
          className="general_div5658 sidebar_menu"
          style={{
            display: "none",
          }}
        >
          <p
            style={{
              color: "#fff",
              fontSize: "15px",
              fontWeight: "600",
              textAlign: "left",
              marginTop: "15px",
              marginLeft: "15px",
            }}
          >
            GENERAL
          </p>
          <ul className="nav Menu_Nav accordion" id="sidemenu">
            {/***Menu 1 Dashboard***/}
            <li className="menuline">
              <NavLink to="/cc" className="" onClick={handlClick}>
                <i class="fa-solid fa-gear"></i>
                <span>Settings</span>
              </NavLink>
            </li>
            <li className="menuline">
              <NavLink to="/cc" className="" onClick={handlClick}>
                <i class="fa-solid fa-shield"></i>
                <span>Security</span>
              </NavLink>
            </li>
          </ul>
        </div>

        <div
          style={{
            paddingBottom: "5px",
          }}
        >
          <hr
            className="hr_line"
            style={{
              marginTop: "0px",
              marginBottom: "10px",
            }}
          />
          <div
            className="Accountdetails"
            style={{
              width: "85%",
              marginInline: "auto",
            }}
          >
            <div
              className="profile_pic"
              style={{
                width: "30px",
                minWidth: "30px",
                height: "30px",
              }}
            >
              <img src={profileP} className="img-fluid" alt="user" />
            </div>
            <div className="namearea">
              <div className="dropdown">
                <Link
                  className="dropdown-toggle"
                  href="#"
                  id="accountDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#fff",
                      marginBottom: "0px",
                    }}
                  >
                    {profileData?.name}
                  </p>
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "600",

                      marginTop: "0px",
                      color: "grey",
                    }}
                  >
                    {profileData?.email}
                  </p>
                </Link>
                <div
                  className="dropdown-menu"
                  aria-labelledby="accountDropdown"
                >
                  {/* <Link className="dropdown-item"><i className="fa-solid fa-user mr-1"></i> Profile</Link> */}

                  <div className="">
                    <button className="dropdown-item" onClick={handleLogOut}>
                      <i className="fa-solid fa-right-from-bracket mr-1"></i>{" "}
                      Log Out
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
